import { useEffect } from 'react';
import { Icon } from './Icon';

interface PrivacyModalProps {
  open: boolean;
  onClose: () => void;
}

export function PrivacyModal({ open, onClose }: PrivacyModalProps): JSX.Element | null {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose, open]);

  if (!open) return null;
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="modal privacy-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="modal__header">
          <span className="eyebrow">PRIVACIDADE</span>
          <button type="button" className="icon-button" onClick={onClose} aria-label="Fechar política de privacidade">
            <Icon name="close" />
          </button>
        </div>
        <h2 id="privacy-title">Seus dados ficam a serviço da sua experiência no evento.</h2>
        <p>
          Para realizar sua inscrição, nós tratamos os dados informados exclusivamente para organizar o 12 HORAS COM FORTEENS.
        </p>
        <ul className="privacy-list">
          <li>criar e localizar sua inscrição;</li>
          <li>viabilizar e confirmar o pagamento;</li>
          <li>comunicar informações do evento por WhatsApp API Oficial e e-mail;</li>
          <li>enviar confirmação, código e QR Code;</li>
          <li>organizar equipes e a operação interna;</li>
          <li>planejar o cuidado com restrições alimentares informadas;</li>
          <li>controlar a entrada e o check-in com segurança.</li>
        </ul>
        <p className="muted">Não vendemos seus dados. O acesso é restrito à equipe responsável pelo evento e aos provedores necessários para a operação.</p>
        <button type="button" className="button button--primary button--full" onClick={onClose}>Entendi</button>
      </section>
    </div>
  );
}
